angular.module('app.factories').factory('investmentsListFilterFactory', ($translate, $state, $log, listFilter) => {
    const investmentsListFilter = listFilter;

    investmentsListFilter
        .setAttributes({
            extendByDates: false,
            name: 'investmentsListFilter',
            providers: [],
        })
        .setFields({
            filter: {
                type: 'text',
                class: 'uk-width-medium-3-4',
                label: $translate.instant('search'),
                default: '',
            },
            reset: {
                type: 'reset',
                class: 'uk-width-medium-1-4',
            },
        }).listFilter = (investment) => {
        if (!investment || !investmentsListFilter.fields.filter.value) {
            return true;
        }

        const parts = investmentsListFilter.fields.filter.value.split('+');
        const regExp = new RegExp(parts.join('|'), 'i');
        const subject = [investment.name, investment.description, investment.client.name].join(' ');

        return regExp.test(subject);
    };

    return investmentsListFilter;
});
